import { get, post } from './requests'

export const getBlockedUsers = key => get(['user', 'blocking'], { key })
export const unblockUser = key => username => post(['users', username, 'unblock'], { key })
